export default __webpack_public_path__ + "static/media/whatsapp.33c16575.png";